/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
// css
import { EventFloatingButtonStyle } from './index.style'
import { Schema$GameBanner } from '@interface/common'
// img
import pybkBgIconImg from '@assets/images/icon/pybk_icon/pybk_effect_bg.png'
import pybkGiftBoxIconImg from '@assets/images/icon/pybk_icon/pybk_gift_box.png'
import pybkTwinkleIconImg from '@assets/images/icon/pybk_icon/pybk_twinkle.png'
import pybkTxtIconImg from '@assets/images/icon/pybk_icon/pybk_txt.png'

interface EventFloatingButtonProps {
  className?: string
}

const EventFloatingButton: React.FC<EventFloatingButtonProps> = observer((props: EventFloatingButtonProps) => {
  const { globalStore, componentStore, userStore, authStore, logStore } = useRootStore()
  const { paymentReward } = userStore
  const paymentRewardEventEnabled = globalStore.getPaymentRewardEventEnabled()
  const { className } = props

  useEffect(() => {
    if (authStore.isSignedIn) {
      userStore.fetchPaymentReward()
    } else {
      userStore.resetPaymentReward()
    }
  }, [authStore.isSignedIn])

  const isEndedEvent = () => {
    if (paymentReward) {
      const reward = paymentReward.paymentRewardInfos.find(e => e.isReceived === false)
      return !reward
    }

    // 결제보상 이벤트 모두 완료시 버튼 비활성화.
    // 새로고침시 순간 보였다 안보이는 부분 예외처리
    if (authStore.isSignedIn && paymentReward === null) {
      return true
    }

    return false
  }


  const onClickBanner = () => {
    logStore.writeButtonLog({ pageId: 'd020', buttonId: '002' }).catch(console.error)

    if (!paymentRewardEventEnabled) {
      return
    }

    componentStore.setSelectedGameBanner({ order: 3 } as Schema$GameBanner)
    globalStore.setVisibleMatchupBanner(true)
  }

  let eventFloatingBtnClassName = 'payback-btn'

  if (userStore.isRegisteredTelegram() === true) {
    eventFloatingBtnClassName = 'payback-btn no-telegram-btn'
  }

  return ((paymentRewardEventEnabled && isEndedEvent() === false) &&
    <Button TP css={EventFloatingButtonStyle}
            className={`${eventFloatingBtnClassName} ${className}`}
            onClick={onClickBanner}>
      <div className="payback-icon-wrap">
        <img src={pybkBgIconImg} alt="페이백 배경빛 아이콘" className="payback-icon--bg"/>
        <img src={pybkGiftBoxIconImg} alt="페이백 선물상자 아이콘" className="payback-icon--gift-box"/>
        <img src={pybkTwinkleIconImg} alt="페이백 반짝이 아이콘" className="payback-icon--twinkle"/>
        <img src={pybkTwinkleIconImg} alt="페이백 반짝이 아이콘" className="payback-icon--twinkle"/>
        <img src={pybkTwinkleIconImg} alt="페이백 반짝이 아이콘" className="payback-icon--twinkle"/>
        <img src={pybkTwinkleIconImg} alt="페이백 반짝이 아이콘" className="payback-icon--twinkle"/>
        <img src={pybkTxtIconImg} alt="페이백" className="payback-icon--txt"/>
      </div>
    </Button>
  )
})

export default EventFloatingButton

